import React, { useContext } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { Button } from '../UiKit/Button';
import { Txt } from '../UiKit/Txt';

export const Disclaimer = React.memo((props) => {



  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;

  return (
    <>


      <div className="x_edu_content x_edu_content--disclaimer">
      <div className="x_edu_disclaimer0">







          <div className="x_edu_content_h x_edu_content_h--2 _fc">
          {
            <>
              {$ui('disclaimer_title')}

            </>}
        </div>
          {Boolean($ui('disclaimer_info', 'rich')) &&
          <Txt>
            {$ui('disclaimer_info', 'rich')}
          </Txt>
          }
          {Boolean(context.me) && <div className="_f _fc">
          <Button ghost onClick={() => context.setState.setFaqShown(true)}>{$ui('disclaimer_info')}</Button>
        </div>}











      </div>
      </div>




    </>
  )
})


